import React from 'react';
import { Link } from 'react-router-dom';

import ROUTES from 'routes';
import { useAppSelector } from 'hooks';
import { selectCounters } from 'redux/counters/selectors';
import Icon from 'components/Icon';
import Typography from 'components/ui/Typography';

import css from 'components/Header/Header.module.scss';

const formatCounter = (count: number) => (count > 99 ? '99+' : count);

const MessagesButton: React.FC = () => {
    const { new_messages } = useAppSelector(selectCounters);

    return (
        <div className={css.flexWrapper}>
            <Link to={ROUTES.MESSAGES_HOME} className={css.headerButton}>
                <Icon name="envelope" width={24} color="white" />
                {new_messages > 0 && (
                    <div className={css.badge}>
                        <Typography style="BadgeBold" color="white">
                            {formatCounter(new_messages)}
                        </Typography>
                    </div>
                )}
            </Link>
        </div>
    );
};

export default MessagesButton;
